require('./bootstrap');
require('./components/global.js');
require('./components/sidebarToggler.js');
require('./components/casinos.js');
require('./components/slots.js');
require('./components/modal.js');
require('./components/dropdown.js');
